/* @jsxImportSource react */

import type { PropsWithChildren } from 'react';
import React from 'react';

export type OutlinedCardProps = PropsWithChildren &
  Pick<React.HTMLAttributes<HTMLDivElement>, 'className'>;

export const OutlinedCard = ({ children, className }: OutlinedCardProps) => (
  <div className={`border-color-grey rounded border p-1.5 ${className ?? ''}`}>{children}</div>
);
